const size = {
    huge: 32,
    title: 28,
    subtitle: 22,
    body: 19,
    label: 16,
    small: 14,
    tiny: 12
};

const weight = {
    bold: '700',
    medium: '500',
    regular: '400',
    light: '300'
};

export default {
    size,
    weight
};